import * as React from "react";
import { Route, Router, Switch, Redirect } from "react-router";
import Footer from "../../layouts/Footer";
import Header from "../../layouts/Header";
import Layout from "../../layouts/Layout";
import { MapRoot, MapExportRoot } from "./MapRoot";
import { MapReportingProvider } from "./MapReportingProvider";
import { FavouriteProvider } from "./providers/FavouriteProvider";

export default function MapModule() {
  return (
    <Switch>
      <Route path="/maps/export" component={MapExportApp} />
      <Route path="/maps" component={MapApp} />
    </Switch>
  );
}

export function MapApp() {
  return (
    <Layout>
      <Header />
      <MapReportingProvider>
        <FavouriteProvider>
          <MapRoot />
        </FavouriteProvider>
      </MapReportingProvider>
      <Footer />
    </Layout>
  );
}

export function MapExportApp() {
  return (
    <Layout isExport>
      {/* <Header /> */}
      <MapReportingProvider>
        <FavouriteProvider>
          <MapExportRoot />
        </FavouriteProvider>
      </MapReportingProvider>
      {/* <Footer /> */}
    </Layout>
  );
}
